<template>
  <div class="logoutButton">
    <el-link
      v-if="$store.getters['auth/logged_in']"
      :underline="false"
      @click="$store.dispatch('auth/logout')"
    >
      <span class="logoutButton__content"><i class="el-icon-switch-button el-icon--left"></i>{{ $t('nav.logout') }}</span>
    </el-link>
  </div>
</template>

<script>
export default {
  name: "LogoutButton"
}
</script>

<style lang="scss" scoped>
$c: '.logoutButton';

#{$c} {
  a {
    cursor: pointer;
    border: 1px solid #e7e7e7;
    height: 34px;
    width: 121px;
    border-radius: 6px;
    box-shadow: 0 2px 4px 0 rgba(180, 180, 180, 0.5);
  }
  &__content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 18px;
  }
}
</style>